import React from "react";
import { Link } from "react-router-dom";

const PaymentDone = () => {
  return (
    <React.Fragment>
        <section className="fore-zero padding-tb">
          <div className="container">
            <div className="section-wrapper">
            <section className="whybat-section padding-tb bg-flower-img">
              <div className="container">

                  <div className="section-header">
                    {/* <h2
                      data-description="title"
                      className="color-red-bat-home mt-20 responsive-title text-center"
                    >
                      Payment Successfully Completed!
                    </h2> */}
                    <h5 className="mb-20 mt-20  text-center">
                        Thank you for your kind donation of $50 to the Brahmin Association of Texas. You will receive an email confirmation for the donation. After the donation has been processed, your matrimony profile will be live.
                    </h5>
                  </div>
                  <div className = "account-bottom1  text-center">
                    <button className="button login-btn create-btn text-white text-center">
                      <Link to="/dashboard">Go Back to Dashboard</Link>
                    </button>
                  </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default PaymentDone;
